'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	TITLE: 'Checkout'
});
